const Shimmer = ()=> {
    return (
        <div className = "shimmer-container">
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
            <div className = "shimmer-card">Card</div>
        </div>
    );
}

export default Shimmer;